import { Icon } from "../msd/Icon";

export function ImageViewer({ url, onClose }) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/80 p-4" onClick={onClose}>
      <div
        className="relative flex max-h-[90vh] max-w-[90vw] flex-col overflow-hidden rounded-[20px] bg-black/40 shadow-msd-pop"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute right-2 top-2 z-10 flex items-center gap-2">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex h-[34px] items-center rounded-[10px] bg-black/50 px-3 text-[13px] font-semibold text-white no-underline hover:bg-black/70"
          >
            Open in tab ↗
          </a>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-[34px] w-[34px] items-center justify-center rounded-full border-0 bg-black/50 text-white hover:bg-black/70"
            aria-label="Close"
          >
            <Icon name="x" size={16} stroke={2.2} />
          </button>
        </div>
        {/* On white, like the bubble: the viewer sits on a dark overlay, and a
            transparent PNG opened from a chat was rendering as a dark shape. */}
        <img
          src={url}
          alt="Full size"
          className="max-h-[85vh] max-w-full rounded-[14px] bg-white object-contain"
        />
      </div>
    </div>
  );
}

export function PdfViewer({ url, onClose }) {
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/70" onClick={onClose}>
      <div
        className="relative flex h-[90vh] w-[90vw] max-w-4xl flex-col overflow-hidden rounded-[20px] bg-msd-surface shadow-msd-pop"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex shrink-0 items-center justify-between px-[18px] py-3 shadow-[0_1px_0_var(--line)]">
          <div className="flex items-center gap-[10px] text-[16px] font-semibold text-msd-ink">
            <span className="flex h-8 w-8 items-center justify-center rounded-[9px] bg-[#F04438] text-white">
              <Icon name="doc" size={16} />
            </span>
            Document
          </div>
          <div className="flex items-center gap-2">
            <a
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex h-[34px] items-center rounded-[10px] bg-msd-surface px-3 text-[13px] font-semibold text-msd-ink no-underline shadow-msd-e1"
            >
              Open in tab ↗
            </a>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex h-9 w-9 items-center justify-center rounded-full border-0 bg-transparent text-msd-muted hover:bg-msd-royal-soft"
              aria-label="Close"
            >
              <Icon name="x" size={18} stroke={2.2} />
            </button>
          </div>
        </div>
        <iframe src={url} title="Document viewer" className="w-full flex-1 border-0 bg-white" />
      </div>
    </div>
  );
}
